export enum UserScope {
    Application = "Application",
    Api = "Api",
    System = "System",
    External = "External",
    Sdk = "Sdk"
}